import { getDetails } from "@/api/homeData";

export default {
  namespaced: true,
  state: {
    dataList1: [
      {
        key: "qyNodeNumber",
        label: "企业节点对接数量",
        unit: "家",
        value: 0,
      },
      {
        key: "qyNumber",
        label: "接入企业数量",
        unit: "家",
        value: 0,
      },
      {
        key: "analysisNumber",
        label: "标识注册量",
        unit: "",
        value: 0,
      },
      {
        key: "identificationNumber",
        label: "标识解析量",
        unit: "",
        value: 0,
      },
    ],
    dataList2: [
      {
        key: "ptQyNumber",
        label: "平台入驻企业数量",
        unit: "家",
        value: 0,
      },
      {
        key: "ptDockNumber",
        label: "平台对接企业数量",
        unit: "家",
        value: 0,
      },
      {
        key: "expertNumber",
        label: "平台专家数量",
        unit: "人",
        value: 0,
      },
      {
        key: "useNumber",
        label: "平台应用数量",
        unit: "个",
        value: 0,
      },
      {
        key: "ptUserNumber",
        label: "平台活跃用户数",
        unit: "人",
        value: 0,
      },
    ],
    loading: false,
  },
  mutations: {
    setDataList(state, data) {
      let dataList1 = JSON.parse(JSON.stringify(state.dataList1)),
        dataList2 = JSON.parse(JSON.stringify(state.dataList2));
      dataList1.forEach(item => {
        if (Object.prototype.hasOwnProperty.call(data, item.key)) {
          item.value = Number(data[item.key]) || 0;
        } else {
          item.value = 0;
        }
      });
      state.dataList1 = dataList1;
      dataList2.forEach(item => {
        if (Object.prototype.hasOwnProperty.call(data, item.key)) {
          item.value = Number(data[item.key]) || 0;
        } else {
          item.value = 0;
        }
      });
      state.dataList2 = dataList2;
    },
    setLoading(state, loading) {
      state.loading = !!loading;
    },
  },
  actions: {
    getDataList({ state, commit }) {
      if (state.loading) return;
      commit("setLoading", true);
      getDetails()
        .then(res => {
          commit("setDataList", res && res.data ? res.data : {});
        })
        .finally(() => {
          commit("setLoading", false);
        });
    },
  },
};
